<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card min-width="500px">
            <v-card-actions class="ma-0 pa-0 pb-3">
                <v-card-text class="blue--text">{{deployedPackage == null ? "" : deployedPackage.name}}</v-card-text>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2 pa-0" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions dense class="ma-0 pa-0 mx-3">
                <v-card elevation="0" class="ma-0 pa-0" width="100%">
                    <common-version-input ref="common-version-input"
                                          :min="deployedPackage == null ? [] : deployedPackage.minver.split('.')"
                                          :max="deployedPackage == null ? [] : deployedPackage.maxver.split('.')"></common-version-input>
                </v-card>
            </v-card-actions>
            <v-card-actions dense class="ma-0 pa-0 mt-7 pb-3">
                <v-spacer></v-spacer>
                <v-btn :loading="working"
                       elevation="0"
                       class="ma-2"
                       color="primary"
                       @click="onPressActivate">SAVE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import CommonVersionInput from "@/modules/mpackages/views/popups/common/common-version-input";
import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";

export default {
    name: "p-packages-edit-version-popup",
    components: {CommonVersionInput},
    data: () => ({
        dialog: false,
        working:false,
        deployedPackage:null,
    }),
    computed: {
    },
    methods: {
        show(deployedPackage) {
            this.deployedPackage = deployedPackage
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onClose(){
            this.dialog = false
        },
        onPressActivate(){
            let version = this.$refs['common-version-input'].validate()
            if (version.length == 0) {
                this.$notify({title: 'No version!', type: "error"});
                return;
            }
            let data = [{name: this.deployedPackage.name, minver:version[0].join("."), maxver:version[1].join(".")}]
            this.working = true
            PackageStoreUtils.setDeployedPackageClientVersion(data)
            .then(() => {
                this.working = false
                this.dialog = false
                this.$notify({title: 'Package version updated!', text: "", type: "success"});
            })
            .catch((error) => {
                this.working = false
                this.$notify({title: 'Error update version!', text: error, type: "error"});
            })
        }
    }
}
</script>

<style scoped>
</style>